module.exports = __webpack_public_path__ + "img/umbrellatree-colab.68013bbf.png";